<template>
  <div class="container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="成员列表" name="0">
        <el-button
          size="lager"
          style="margin-bottom: 20px"
          type="primary"
          @click="handleMemberExport"
          >导出</el-button
        >
        <vxe-table
          :data="tableData"
          border
          stripe
          resizable
          highlight-cell
          highlight-hover-row
          min-height="750"
          max-height="750"
          class="mytable-scrollbar"
          show-overflow
          keep-source
          align="center"
          :highlight-current-column="true"
        >
          <vxe-table-column field="id" title="ID" width="80">
          </vxe-table-column>
          <vxe-table-column field="username" title="姓名" width="100">
          </vxe-table-column>
          <vxe-table-column field="sex" title="性别" width="100">
            <template slot-scope="scope">
              {{ scope.row.sex == 1 ? "男" : "女" }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="logo" title="头像" width="100">
            <template slot-scope="scope">
              <img
                v-if="scope.row.logo"
                :src="$ReturnImgUrl(scope.row.logo)"
                alt=""
                style="width: 50px; height: 50px"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="mobile" title="手机号" width="120">
          </vxe-table-column>
          <vxe-table-column field="email" title="邮箱" min-width="200">
          </vxe-table-column>
          <vxe-table-column field="area_name" title="地区" min-width="100">
          </vxe-table-column>
          <vxe-table-column field="idcard" title="身份证号" width="200">
          </vxe-table-column>
          <vxe-table-column field="education" title="学历" width="100">
            <template slot-scope="scope">
              {{ getEducationListName(scope.row.education) }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="work_unit" title="工作单位" min-width="200">
          </vxe-table-column>
          <vxe-table-column field="role" title="职务" width="120">
          </vxe-table-column>
          <vxe-table-column field="is_party" title="是否党员" width="100">
            <template slot-scope="scope">
              {{ scope.row.is_party === "1" ? " 是" : "否" }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="party_document" title="党员凭证" width="120">
            <template slot-scope="scope">
              <img
                v-for="(item, index) in scope.row.party_document"
                :key="index"
                :src="$ReturnImgUrl(item)"
                alt=""
                style="width: 50px; height: 50px"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="is_zdy" title="是否指导员" width="100">
            <template slot-scope="scope">
              {{ scope.row.is_zdy === "1" ? " 是" : "否" }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="zdy_document" title="指导员凭证" width="320">
            <template slot-scope="scope">
              <img
                v-for="(item, index) in scope.row.zdy_document"
                :key="index"
                :src="$ReturnImgUrl(item)"
                alt=""
                style="width: 50px; height: 50px"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">通过</span>
              <span v-else-if="scope.row.status == 2">驳回</span>
              <span v-else>申请</span>
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作" min-width="180" fixed="right">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0" class="rou">
                <el-button
                  size="small"
                  type="primary"
                  @click="shenhe(scope.row, 1)"
                >
                  通过
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="shenhe(scope.row, 2)"
                >
                  驳回
                </el-button>
              </div>
              <div v-if="scope.row.status == 1">
                <el-button
                  size="mini"
                  type="warning"
                  @click="
                    handleMemberEditStatus({
                      id: scope.row.id,
                      bus_id: scope.row.bus_id,
                      status: 2,
                    })
                  "
                  >踢出</el-button
                >
                <el-button
                  size="mini"
                  type="default"
                  @click="
                    handleMemberEdit(scope.row)
                  "
                  >编辑</el-button
                >
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>

        <div v-if="pageshow">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="query.page"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="申请列表" name="1">
        <vxe-table
          :data="tableData2"
          border
          stripe
          resizable
          highlight-cell
          highlight-hover-row
          max-height="750"
          class="mytable-scrollbar"
          show-overflow
          keep-source
          align="center"
          :highlight-current-column="true"
        >
          <vxe-table-column field="id" title="ID" width="80">
          </vxe-table-column>
          <vxe-table-column field="username" title="姓名" width="100">
          </vxe-table-column>
          <vxe-table-column field="sex" title="性别" width="100">
            <template slot-scope="scope">
              {{ scope.row.sex == 1 ? "男" : "女" }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="logo" title="头像" width="100">
            <template slot-scope="scope">
              <img
                v-if="scope.row.logo"
                :src="$ReturnImgUrl(scope.row.logo)"
                alt=""
                style="width: 50px; height: 50px"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="mobile" title="手机号" width="120">
          </vxe-table-column>
          <vxe-table-column field="email" title="邮箱" min-width="200">
          </vxe-table-column>
          <vxe-table-column field="area_name" title="地区" min-width="100">
          </vxe-table-column>
          <vxe-table-column field="idcard" title="身份证号" width="200">
          </vxe-table-column>
          <vxe-table-column field="education" title="学历" width="100">
            <template slot-scope="scope">
              {{ getEducationListName(scope.row.education) }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="work_unit" title="工作单位" min-width="200">
          </vxe-table-column>
          <vxe-table-column field="role" title="职务" width="120">
          </vxe-table-column>
          <vxe-table-column field="is_party" title="是否党员" width="100">
            <template slot-scope="scope">
              {{ scope.row.is_party === "1" ? " 是" : "否" }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="party_document" title="党员凭证" width="120">
            <template slot-scope="scope">
              <img
                v-for="(item, index) in scope.row.party_document"
                :key="index"
                :src="$ReturnImgUrl(item)"
                alt=""
                style="width: 50px; height: 50px"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="is_zdy" title="是否指导员" width="100">
            <template slot-scope="scope">
              {{ scope.row.is_zdy === "1" ? " 是" : "否" }}
            </template>
          </vxe-table-column>
          <vxe-table-column field="zdy_document" title="指导员凭证" width="320">
            <template slot-scope="scope">
              <img
                v-for="(item, index) in scope.row.zdy_document"
                :key="index"
                :src="$ReturnImgUrl(item)"
                alt=""
                style="width: 50px; height: 50px"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">通过</span>
              <span v-else-if="scope.row.status == 2">驳回</span>
              <span v-else>申请</span>
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作" min-width="180" fixed="right">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0" class="rou">
                <el-button
                  size="small"
                  type="primary"
                  @click="shenhe(scope.row, 1)"
                >
                  通过
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="shenhe(scope.row, 2)"
                >
                  驳回
                </el-button>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>

        <div v-if="pageshow2">
          <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="query2.page"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <Compile ref="Compile" @submit="getList" />

  </div>
</template>

<script>
import { MessageBox, message } from "element-ui";

import {
  businessassociation_members_applying,
  businessassociation_members,
  businessassociation_member_audit,
  businessassociationMemberEdit,
} from "@/api/shangxiehui";

import Compile from "../shangxiehuiguanli/components/Compile.vue";

export default {
  components: { Compile },
  data() {
    return {
      activeName: "0",
      query: {
        token: sessionStorage.getItem("token"),
        bus_id: "",
        page: 1,
        pagesize: 10,
      },
      tableData: [],
      pageshow: true,
      total: null,
      query2: {
        token: sessionStorage.getItem("token"),
        bus_id: "",
        page: 1,
        pagesize: 10,
      },
      tableData2: [],
      pageshow2: true,
      total2: null,
      educationList: [
        {
          name: "小学",
          code: 1,
        },
        {
          name: "初中",
          code: 2,
        },
        {
          name: "高中",
          code: 3,
        },
        {
          name: "大专",
          code: 4,
        },
        {
          name: "本科",
          code: 5,
        },
        {
          name: "硕士",
          code: 6,
        },
        {
          name: "博士",
          code: 7,
        },
      ],
    };
  },
  methods: {
    // 修改成员
    async handleMemberEditStatus({ id, bus_id, status }) {
      MessageBox.confirm(`确定踢出该成员?`, {
        type: "wwarning",
      }).then(async () => {
        const editStatusResp = await businessassociationMemberEdit({
          token: sessionStorage.getItem("token"),
          bus_id,
          id,
          status,
        });
        // console.log("_editStatusResp", editStatusResp)
        const { result, data, msg } = editStatusResp.data;
        if (result === 1) {
          this.$message({
            message: msg,
            type: "success",
            duration: "2000",
          });
          this.getList();
        } else {
          this.$message({
            message: msg,
            type: "error",
            duration: "2000",
          });
        }
      });
    },
    handleMemberEdit(row) {
      this.$refs.Compile.handleOpenDialog(row);
      console.log("row",row);
    },
    handleMemberExport() {
      const bus_id = this.tableData[0].bus_id;
      const token = sessionStorage.getItem("token");
      const exportLink = `https://ydmxhapi.yundongm.cn:8099/service/admin/business_member_export?token=${token}&bus_id=${bus_id}`;
      window.location.href = exportLink;
    },
    initData() {
      //  成员列表中显示了未通过的成员
      this.getList();
      //  申请列表
      this.getList2();
    },
    getList() {
      businessassociation_members(this.query).then(({ data: res }) => {
        // 处理图片
        res.list = res.list.map((item) => ({
          ...item,
          party_document: item.party_document
            ? item.party_document.split(",")
            : [],
          zdy_document: item.zdy_document ? item.zdy_document.split(",") : [],
        }));
        console.log("getList", res.list);
        this.tableData = res.list;
        this.total = res.total;
      });
    },
    getList2() {
      businessassociation_members_applying(this.query2).then(
        ({ data: res }) => {
          res.list = res.list.map((item) => ({
            ...item,
            party_document: item.party_document
              ? item.party_document.split(",")
              : [],
            zdy_document: item.zdy_document ? item.zdy_document.split(",") : [],
          }));
          this.tableData2 = res.list;
          this.total2 = res.total;
        }
      );
    },
    getEducationListName(value) {
      return (
        (this.educationList.find((item) => item.code == value) || {}).name || ""
      );
    },
    shenhe(row, status) {
      const message = status == 1 ? "审核通过" : "审核驳回";
      this.$confirm("确认" + message + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem("token"),
            bus_id: row.bus_id,
            member_id: row.id,
            status,
          };
          businessassociation_member_audit(obj).then(({ data: res }) => {
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              setTimeout(() => {
                window.sessionStorage.clear();
                this.$router.push("/login");
              }, 1000);
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              return false;
            }
            if (res.result === 1) {
              this.$message({
                message: message,
                type: "success",
                duration: "2000",
              });
              this.getList();
              this.getList2();
            }
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.query.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    handleSizeChange2(val) {
      this.query2.pagesize = val;
      this.getList2();
    },
    handleCurrentChange2(val) {
      this.query2.page = val;
      this.getList2();
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
